import { useCallback, useMemo } from 'react';
import { useFetchAllShiplists } from '@ais-ui/api';
import { ShipList } from '@ais-ui/api-spec/config';
import { SelectData } from '@ais-ui/ui-core';
import { useLocalization } from '@ais-ui/locale-management';
import * as Sentry from '@sentry/react';

export const SHIPLIST_NO_FILTER_ID = 'no-filter';
export const SHIPLIST_LABEL = 'Shiplist:';

export function useShiplistSelections() {
  const { data: shiplists } = useFetchAllShiplists();
  const { messages } = useLocalization();

  const selections = useMemo(() => {
    const selectionItems: SelectData[] =
      shiplists && shiplists.records
        ? shiplists.records.map((shiplist: ShipList) => ({
            id: shiplist.id ? shiplist.id : '',
            name: shiplist.name ? shiplist.name : '',
          }))
        : [];
    selectionItems.unshift({
      id: SHIPLIST_NO_FILTER_ID,
      name: messages.reportsCreateReportNoShiplistValue ?? 'No shiplist',
    });
    return selectionItems;
  }, [shiplists, messages]);

  const placeholder =
    messages.reportsCreateReportSelectShiplistPlaceholder ??
    'Select a shiplist';
  const notFoundText = messages.shiplistNotFound || 'Shiplist not found';

  const handleNotFound = useCallback((shiplistId: string) => {
    Sentry.captureMessage('Shiplist not found in report filter', {
      level: 'warning',
      tags: { component: 'ShiplistFilter', context: 'shiplist-not-found' },
      extra: { missingShiplistId: shiplistId },
    });
  }, []);

  return { selections, placeholder, notFoundText, handleNotFound };
}
